export default "__VITE_ASSET__C2JlIf9$__"